
export default {
  namespaced: true,
  state: {
    xAuthToken: ''
  },
  actions: {
  },
  mutations: {
    setXAuthToken(state, token) {
      state.xAuthToken = token;
    }
  },
  getters: {
  }
};
